import Link from 'next/link'
import type { ReactNode } from 'react'

type AuthShellProps = {
  title: string
  subtitle: string
  children: ReactNode
  footerText?: string
  footerLinkHref?: string
  footerLinkLabel?: string
}

export default function AuthShell({
  title,
  subtitle,
  children,
  footerText,
  footerLinkHref,
  footerLinkLabel,
}: AuthShellProps) {
  return (
    <main className="min-h-screen bg-gradient-to-b from-brand-green-soft to-white pb-16 px-4">
      <div className="max-w-xl mx-auto bg-white border border-brand-cool-gray rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-brand-charcoal">{title}</h1>
        <p className="mt-2 text-brand-charcoal-75">{subtitle}</p>
        <div className="mt-8">{children}</div>
        {footerText && footerLinkHref && footerLinkLabel ? (
          <p className="mt-6 text-sm text-brand-charcoal-75">
            {footerText}{' '}
            <Link href={footerLinkHref} className="font-semibold text-brand-green hover:text-brand-green">
              {footerLinkLabel}
            </Link>
          </p>
        ) : null}
      </div>
    </main>
  )
}
